import _ from "underscore";
import { TFieldIdClass, TFieldDefClass } from "../types/api/APIClassTypes";

const createReservationGroupNameFromTrack = (track) => {
    // eslint-disable-next-line no-console
    console.log(track);
    const firstActivity = track[0];
    return `${firstActivity.primaryObject}-${firstActivity.track}`;
};

// Checks the categories object, returns all field ids for which matchAll should be active
// If fieldDefs are provided, also filters out any fields which do not allow multiple values
const getMatchAllIds = (categories, fieldDefs?) => {
    const matchAllIds: number[] = [];

    Object.keys(categories).forEach((key) => {
        const values = categories[key];
        let matchAll = false;
        if (values.length > 1) {
            matchAll = _.every(values, (vl) => vl.length === 1);
        }
        const fieldId = parseInt(key, 10);
        if (fieldDefs) {
            const def = _.find(fieldDefs, (df) => df.id === fieldId);
            if (def && !def.multiple) {
                matchAll = false;
            }
        }
        if (matchAll) {
            matchAllIds.push(fieldId);
        }
    });
    return matchAllIds;
};

const getCategoryValues = (
    searchCriteria,
    fields: TFieldIdClass[],
    fieldDefs: TFieldDefClass[]
) => {
    const categoryValues = {};
    const removedValues: string[] = [];
    searchCriteria.categories.forEach((category) => {
        const field = fields.find((f) => f.extid === category.id);
        if (!field) {
            return;
        }
        const def = _.find(fieldDefs, (df) => df.id === field.id);
        if (category && Array.isArray(category.values)) {
            const finalValues = category.values
                .flat()
                .map((val) => val.trim())
                .filter((val) => {
                    const exists = def.categories ? def.categories.indexOf(val) !== -1 : false;
                    if (!exists) {
                        removedValues.push(val);
                        return false;
                    }
                    return true;
                });
            if (finalValues.length > 0) {
                if (!categoryValues[field.id]) {
                    categoryValues[field.id] = [finalValues];
                } else {
                    categoryValues[field.id].push(finalValues);
                }
            }
        }
    });
    const matchAllIds = getMatchAllIds(categoryValues, fieldDefs);

    return { categoryValues, matchAllIds };
};

export default { createReservationGroupNameFromTrack, getMatchAllIds, getCategoryValues };
